import { render, staticRenderFns } from "./metaAdjustOrderTrip.vue?vue&type=template&id=f58221ba&scoped=true"
import script from "./metaAdjustOrderTrip.vue?vue&type=script&lang=js"
export * from "./metaAdjustOrderTrip.vue?vue&type=script&lang=js"
import style0 from "./metaAdjustOrderTrip.vue?vue&type=style&index=0&id=f58221ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58221ba",
  null
  
)

export default component.exports